import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const getLocalAuctionDateTime = (auctionDate?: string): Dayjs => {
  if (!auctionDate) {
    return dayjs().startOf('day');
  }

  const parsedAuctionDate = dayjs.utc(auctionDate);

  return parsedAuctionDate.isValid()
    ? parsedAuctionDate.local()
    : dayjs().startOf('day');
};

export const getUtcAuctionDateTime = (auctionDate: Dayjs): string =>
  auctionDate.second(0).millisecond(0).toISOString();
